An svg of a vase with flowers
<template>
	<svg
		class='flower-vase-icon svg-flex-sizing'
		fill='none'
		preserveAspectRatio='xMidYMid meet'
		viewBox='0 0 69 142'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			:class='getFlowerClasses'
			d='M28.807 11.1359C31.8766 11.1359 34.365 8.64304 34.365 5.56795C34.365 2.49285 31.8766 0 28.807 0C25.7374 0 23.249 2.49285 23.249 5.56795C23.249 8.64304 25.7374 11.1359 28.807 11.1359Z'
		/>
		<path
			:class='getFlowerClasses'
			d='M34.305 23.2144C37.3746 23.2144 39.863 20.7216 39.863 17.6465C39.863 14.5714 37.3746 12.0786 34.305 12.0786C31.2355 12.0786 28.7471 14.5714 28.7471 17.6465C28.7471 20.7216 31.2355 23.2144 34.305 23.2144Z'
		/>
		<path
			:class='getFlowerClasses'
			d='M23.1869 23.1576C26.2565 23.1576 28.7448 20.6648 28.7448 17.5897C28.7448 14.5146 26.2565 12.0217 23.1869 12.0217C20.1173 12.0217 17.6289 14.5146 17.6289 17.5897C17.6289 20.6648 20.1173 23.1576 23.1869 23.1576Z'
		/>
		<path
			:class='getFlowerClasses'
			d='M34.2425 35.5843C37.3121 35.5843 39.8005 33.0915 39.8005 30.0164C39.8005 26.9413 37.3121 24.4484 34.2425 24.4484C31.173 24.4484 28.6846 26.9413 28.6846 30.0164C28.6846 33.0915 31.173 35.5843 34.2425 35.5843Z'
		/>
		<path
			:class='getFlowerClasses'
			d='M23.1234 35.5277C26.193 35.5277 28.6814 33.0348 28.6814 29.9597C28.6814 26.8846 26.193 24.3918 23.1234 24.3918C20.0538 24.3918 17.5654 26.8846 17.5654 29.9597C17.5654 33.0348 20.0538 35.5277 23.1234 35.5277Z'
		/>
		<path
			d='M30.2212 78.732C30.1377 78.732 30.0527 78.714 29.9721 78.676C29.6795 78.538 29.554 78.1885 29.6916 77.8953L51.0758 32.3837C51.2136 32.0905 51.5625 31.9648 51.8551 32.1026C52.1478 32.2407 52.2733 32.5902 52.1357 32.8834L30.7514 78.395C30.6517 78.6074 30.441 78.732 30.2212 78.732Z'
			fill='#00141E'
		/>
		<path
			d='M67.33 20.7131C66.367 19.9871 64.9989 20.1795 64.2729 21.1433C65.0266 20.201 64.8751 18.825 63.9345 18.0697C62.9939 17.3144 61.6204 17.4664 60.8664 18.4086C60.8393 18.4427 60.8131 18.4773 60.7881 18.5129L54.1194 27.341L56.7236 16.5845C57.0412 15.4197 56.3558 14.2173 55.1931 13.8993C54.0303 13.5813 52.8301 14.2678 52.5127 15.4326C52.5025 15.4696 52.4936 15.5067 52.4854 15.5441C52.803 14.3792 52.1176 13.1769 50.9548 12.8589C49.7921 12.5409 48.5918 13.2273 48.2744 14.3921C48.2643 14.4291 48.2553 14.4663 48.2471 14.5036L47.9015 15.9176L45.5589 25.4576C44.735 28.8297 45.9669 32.3717 48.7039 34.5009L48.6863 34.5224C49.6798 35.2564 50.8074 35.788 52.0051 36.087V36.0596C55.3819 36.8366 58.899 35.5529 60.9853 32.7818L66.8869 24.9355L67.7615 23.7718C68.4842 22.8074 68.2911 21.439 67.33 20.7131Z'
			fill='white'
		/>
		<path
			d='M53.9663 36.8694C53.3315 36.8694 52.6919 36.8047 52.0563 36.6717C51.9925 36.6772 51.9273 36.6725 51.8634 36.6564C50.5849 36.3373 49.3989 35.7783 48.3387 34.9946C48.284 34.9542 48.2374 34.9051 48.2001 34.8495C45.3858 32.5699 44.127 28.8502 44.9898 25.3181L47.6781 14.3641C47.6849 14.3314 47.6964 14.2843 47.7093 14.2374C48.1114 12.7624 49.6365 11.8901 51.1089 12.2928C51.8222 12.488 52.4169 12.9497 52.7837 13.593C52.8278 13.6704 52.868 13.7496 52.9043 13.8298C53.0113 13.7457 53.1251 13.669 53.2454 13.6002C53.8875 13.2327 54.634 13.1381 55.3473 13.3332C56.0607 13.5284 56.6553 13.9902 57.022 14.6334C57.3886 15.2766 57.4833 16.0245 57.2884 16.7391L55.3524 24.7363L60.321 18.159C60.3419 18.1289 60.3749 18.0851 60.4092 18.042C61.3639 16.8487 63.1096 16.6558 64.3006 17.6122C64.9804 18.158 65.3349 18.9618 65.3366 19.7732C66.1218 19.5749 66.9867 19.7202 67.682 20.2446C67.6822 20.2448 67.6822 20.2448 67.6824 20.245C68.8989 21.1638 69.1443 22.9042 68.2296 24.1245L61.4529 33.1353C59.6604 35.5158 56.867 36.8694 53.9663 36.8694ZM52.005 35.473C52.0487 35.473 52.0926 35.4779 52.1359 35.4879C55.2831 36.2119 58.573 35.0113 60.5174 32.4285L67.2932 23.4189C67.8203 22.7156 67.6789 21.712 66.9775 21.182C66.2885 20.6627 65.3119 20.7873 64.7736 21.4538C64.7592 21.4728 64.7445 21.4917 64.7295 21.5103C64.5292 21.7607 64.1657 21.8035 63.9129 21.6065C63.6603 21.4096 63.6121 21.046 63.8049 20.79C63.8194 20.7709 63.834 20.7519 63.8489 20.7333C64.3613 20.0465 64.2407 19.068 63.5679 18.5278C62.8808 17.9761 61.8738 18.0874 61.3231 18.7758C61.3032 18.8007 61.284 18.8263 61.2655 18.8523L54.5858 27.6953C54.4183 27.9171 54.1186 27.9906 53.8678 27.8713C53.6171 27.7522 53.4841 27.4731 53.5495 27.203L56.1538 16.4466C56.2704 16.0181 56.2157 15.5866 56.0043 15.2156C55.7928 14.8446 55.4496 14.5781 55.0381 14.4656C54.6266 14.353 54.1959 14.4077 53.8256 14.6195C53.4594 14.829 53.1954 15.1673 53.0808 15.5731C53.0714 15.6152 53.0609 15.657 53.0496 15.6989C52.966 16.0057 52.6535 16.19 52.345 16.1141C52.0366 16.0384 51.8447 15.7302 51.9122 15.4194C51.9214 15.3774 51.9315 15.3355 51.9425 15.2939C52.0225 14.9111 51.9608 14.5174 51.7656 14.175C51.5542 13.804 51.211 13.5374 50.7995 13.425C49.95 13.1928 49.0702 13.6958 48.8383 14.5468C48.8308 14.574 48.8242 14.6011 48.8181 14.6285L48.4693 16.0572L46.1264 25.5978C45.3588 28.74 46.511 32.053 49.062 34.0375C49.1047 34.0708 49.1424 34.1095 49.1738 34.1523C50.0264 34.757 50.9673 35.2008 51.9757 35.4734C51.9862 35.4732 51.9956 35.473 52.005 35.473Z'
			fill='#00141E'
		/>
		<path
			d='M50.4789 24.3002C50.4326 24.3002 50.3857 24.2947 50.3389 24.2832C50.0248 24.2059 49.8325 23.8883 49.9096 23.5736L51.9516 15.2285C52.0287 14.9139 52.3458 14.721 52.6599 14.7985C52.974 14.8757 53.1663 15.1933 53.0892 15.508L51.0471 23.8531C50.9818 24.1206 50.7424 24.3002 50.4789 24.3002Z'
			fill='#00141E'
		/>
		<path
			d='M59.2181 28.4539C59.0955 28.4539 58.9717 28.4154 58.8661 28.3358C58.6078 28.1408 58.5561 27.7729 58.7507 27.5142L63.9104 20.6515C64.1051 20.3928 64.4723 20.341 64.7306 20.536C64.9888 20.7309 65.0406 21.0988 64.8459 21.3576L59.6862 28.2202C59.5712 28.3733 59.3957 28.4539 59.2181 28.4539Z'
			fill='#00141E'
		/>
		<path
			d='M26.4716 78.7318C26.2396 78.7318 26.02 78.5929 25.9281 78.3641L8.99667 36.2613C8.87582 35.9607 9.02107 35.6188 9.32113 35.4978C9.62118 35.3767 9.96243 35.5222 10.0833 35.8228L27.0147 77.9256C27.1355 78.2262 26.9903 78.5681 26.6902 78.6892C26.6186 78.7181 26.5446 78.7318 26.4716 78.7318Z'
			fill='#00141E'
		/>
		<path
			d='M8.2954 48.8482C9.72443 48.2732 12.7523 44.0391 12.7523 44.0391C12.7523 44.0391 7.64336 43.0866 6.21238 43.6616C4.78278 44.2378 4.09013 45.8661 4.66525 47.2983C5.24038 48.7305 6.86579 49.4244 8.2954 48.8482Z'
			fill='white'
		/>
		<path
			d='M7.25354 49.6389C6.80453 49.6389 6.35591 49.548 5.93033 49.3663C5.10083 49.0121 4.45855 48.3556 4.12199 47.5174C3.42719 45.7873 4.26684 43.8134 5.99377 43.1174C7.53856 42.4966 12.3194 43.3616 12.8595 43.4624C13.0565 43.4991 13.2209 43.6341 13.2957 43.8203C13.3704 44.0064 13.345 44.2179 13.2285 44.381C12.9083 44.8286 10.0567 48.7722 8.5137 49.3929C8.10627 49.5568 7.67971 49.6389 7.25354 49.6389ZM7.6637 44.0622C7.12235 44.0622 6.68447 44.1042 6.43049 44.2063C5.30327 44.6606 4.7549 45.9497 5.20859 47.0795C5.42841 47.6269 5.84775 48.0556 6.38949 48.2869C6.93123 48.5181 7.53037 48.5244 8.07679 48.3042C8.07699 48.3042 8.07699 48.3042 8.07718 48.304C8.86627 47.9863 10.5391 46.013 11.7167 44.4569C10.4105 44.2497 8.80653 44.0622 7.6637 44.0622Z'
			fill='#00141E'
		/>
		<path
			d='M19.288 44.4185C17.859 44.9935 12.75 44.0391 12.75 44.0391C12.75 44.0391 15.7759 39.8069 17.205 39.232C18.6346 38.6558 20.26 39.3497 20.8351 40.7819C21.4102 42.214 20.7176 43.8424 19.288 44.4185Z'
			fill='white'
		/>
		<path
			d='M17.7808 45.185C15.7671 45.185 13.0431 44.6906 12.6433 44.6159C12.4465 44.5791 12.282 44.4442 12.2074 44.258C12.1326 44.0718 12.158 43.8604 12.2745 43.6975C12.5945 43.25 15.4444 39.3083 16.9874 38.6875C17.8237 38.3503 18.7413 38.3597 19.5708 38.7139C20.4003 39.0681 21.0425 39.7246 21.3791 40.5629C22.0739 42.2929 21.2342 44.2668 19.5073 44.9628C19.5071 44.9628 19.5071 44.9628 19.5069 44.963C19.1063 45.1242 18.4873 45.185 17.7808 45.185ZM19.2887 44.4186H19.2906H19.2887ZM13.7859 43.622C15.711 43.9279 18.2817 44.1915 19.0704 43.8743C20.198 43.4196 20.7462 42.1308 20.2925 41.0011C20.0727 40.4537 19.6533 40.025 19.1116 39.7937C18.5699 39.5623 17.9707 39.5562 17.4243 39.7765C16.6348 40.0939 14.9629 42.0666 13.7859 43.622Z'
			fill='#00141E'
		/>
		<path
			:class='getFlowerClasses'
			d='M0 31.8941L10.0734 38.7391C10.3544 38.9282 10.7352 38.8535 10.9242 38.5719C10.9674 38.5076 10.998 38.4354 11.0144 38.3597L13.5523 26.4396L0 31.8941Z'
		/>
		<path
			:class='getVaseClasses'
			d='M35.1087 94.9599C35.2551 89.9219 42.5334 86.3083 42.5334 78.1451H13.4004C13.4004 86.1636 20.6236 90.0164 21.0336 94.9213L35.1087 94.9599Z'
			stroke='#00141E'
		/>
		<path
			d='M35.1092 95.5464C35.1086 95.5464 35.1082 95.5464 35.1076 95.5464L21.0325 95.5079C20.7286 95.5071 20.4759 95.2736 20.4506 94.9701C20.2905 93.056 18.9677 91.2685 17.4357 89.1988C15.27 86.2726 12.8154 82.9561 12.8154 78.145C12.8154 77.8209 13.0776 77.5583 13.4011 77.5583H42.5341C42.8575 77.5583 43.1197 77.8209 43.1197 78.145C43.1197 82.95 40.7368 86.1907 38.6343 89.0499C37.0881 91.1525 35.753 92.9684 35.6947 94.9767C35.6853 95.294 35.4258 95.5464 35.1092 95.5464ZM21.5481 94.3359L34.568 94.3715C34.8372 92.2352 36.2268 90.3454 37.691 88.3541C39.5969 85.7622 41.7457 82.8397 41.9347 78.7317H14.0004C14.1951 82.8499 16.411 85.8441 18.3765 88.4998C19.8208 90.4512 21.1912 92.3031 21.5481 94.3359Z'
			fill='#00141E'
			stroke='#00141E'
		/>
		<path
			:class='getVaseClasses'
			d='M48.8644 119.939C48.8579 131.496 39.5004 140.86 27.9639 140.853C16.4273 140.847 7.08048 131.472 7.08692 119.915C7.09082 113.077 10.4291 106.673 16.0281 102.762C19.9872 99.607 21.2171 97.1584 21.0355 94.9387L35.1106 94.9596C35.0482 97.1109 36.1203 99.7439 39.9193 102.771C45.5265 106.682 48.8679 113.094 48.8644 119.939Z'
			stroke='#00141E'
		/>
		<path
			d='M27.9766 141.44C27.9723 141.44 27.9686 141.44 27.9643 141.44C16.1233 141.433 6.49532 131.777 6.50196 119.915C6.50586 112.897 9.9363 106.31 15.6786 102.291C19.1184 99.547 20.6358 97.2255 20.4527 94.9866C20.4392 94.8231 20.4949 94.6614 20.606 94.5409C20.717 94.4202 20.8746 94.3479 21.0372 94.352L35.1123 94.3729C35.2704 94.3731 35.4217 94.4374 35.5318 94.5511C35.6419 94.6647 35.7015 94.8182 35.6968 94.9766C35.6277 97.3593 37.1662 99.8233 40.2703 102.301C46.0227 106.32 49.4543 112.912 49.4508 119.939C49.4441 131.797 39.8117 141.44 27.9766 141.44ZM21.6363 95.5264C21.5612 97.9818 19.877 100.445 16.3935 103.221C16.3839 103.228 16.3739 103.236 16.3638 103.243C10.9257 107.041 7.677 113.274 7.67329 119.916C7.66704 131.131 16.7698 140.26 27.965 140.267C27.9684 140.267 27.9732 140.267 27.9766 140.267C39.1671 140.267 48.2732 131.15 48.2794 119.938C48.2828 113.289 45.0327 107.052 39.5854 103.253C39.5753 103.246 39.5651 103.238 39.5554 103.23C36.3848 100.704 34.6992 98.1214 34.536 95.5454L21.6363 95.5264ZM48.8651 119.939H48.8671H48.8651Z'
			fill='#00141E'
			stroke='#00141E'
		/>
		<path
			d='M34.8888 95.7798H21.0495C20.7261 95.7798 20.4639 95.5171 20.4639 95.193C20.4639 94.869 20.7261 94.6063 21.0495 94.6063H34.8888C35.2123 94.6063 35.4745 94.869 35.4745 95.193C35.4745 95.5171 35.2123 95.7798 34.8888 95.7798Z'
			fill='#00141E'
		/>
		<path
			d='M28.4636 78.6847C28.4626 78.6847 28.4616 78.6847 28.4609 78.6847C28.1374 78.6831 27.8764 78.4193 27.8779 78.0952L28.2215 5.56524C28.2231 5.24118 28.4874 4.9883 28.8099 4.98126C29.1334 4.98283 29.3944 5.24665 29.3929 5.57072L29.0493 78.1007C29.0477 78.4238 28.7857 78.6847 28.4636 78.6847Z'
			fill='#00141E'
		/>
	</svg>
</template>

<script>

export default {
	name: 'FlowerBoxIcon',
	props:
	{
		active:
		{
			default: false,
			required: false,
			type: Boolean,
		}
	},
	computed:
	{
		getFlowerClasses()
		{
			return {
				'flower-active': this.active,
				'flower-inactive': !this.active,
			}
		},
		getVaseClasses()
		{
			return {
				'vase-active': this.active,
				'vase-inactive': !this.active,
			}
		},
	},
}

</script>

<style scoped lang="less">
	.flower-vase-icon {
		.flower-active {
			fill: #82B5A5;
		}
		.flower-inactive {
			fill: #CCD0D2;
		}
		.vase-active {
			fill: #82B5A5;
		}
		.vase-inactive {
			fill: #FFFFFF;
		}
	}
</style>
